import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { gamesQueryOptions } from "@/api/fapinstructor/games/get-games";
import { CustomGameCard } from "@/components/custom-game-card";
import type { GameSummary } from "@fapinstructor/common";
import { Masonry } from "masonic";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/explore-games",
)({
  loader: (opts) =>
    opts.context.queryClient.ensureInfiniteQueryData(gamesQueryOptions()),
  component: ExploreGamesRouteComponent,
});

function ExploreGamesRouteComponent() {
  const gamesQuery = useSuspenseInfiniteQuery(gamesQueryOptions());
  const games = gamesQuery.data.pages.flatMap((p) => p.data);

  return (
    <Page title="Custom Games">
      <Title>Custom Games</Title>
      <Text mb="xl">Explore custom games made by the community.</Text>
      <Stack>
        <Masonry
          key={crypto.randomUUID()}
          items={games}
          columnGutter={16}
          columnWidth={400}
          render={MasonryCard}
        />
        {gamesQuery.hasNextPage ? (
          <Center>
            <Button
              loading={gamesQuery.isFetchingNextPage}
              onClick={() => {
                gamesQuery.fetchNextPage();
              }}
            >
              Load More
            </Button>
          </Center>
        ) : null}
      </Stack>
    </Page>
  );
}

type MasonryCardProps = { data: GameSummary };

function MasonryCard({ data: game }: MasonryCardProps) {
  return <CustomGameCard game={game} />;
}
